(function () {
  'use strict';

  function initializePremiumSearch() {
    const modal = document.getElementById('search-modal');
    const OPEN_CLASS = 'premium-search-modal--open';

    function openSearchModal() {
        modal.classList.add(OPEN_CLASS);
        modal.setAttribute('aria-hidden', 'false');
        document.body.classList.add('premium-search-is-open');

        window.setTimeout(function () {
            input.focus();
        }, 50);
        }

        function closeSearchModal() {
        modal.classList.remove(OPEN_CLASS);
        modal.setAttribute('aria-hidden', 'true');
        document.body.classList.remove('premium-search-is-open');

        input.blur();
        }

    if (
      !modal ||
      modal.dataset.premiumSearchInitialized === 'true'
    ) {
      return;
    }

    modal.dataset.premiumSearchInitialized = 'true';

    const form = modal.querySelector(
      '[data-premium-search-form]'
    );

    const input = modal.querySelector(
      '[data-premium-search-input]'
    );

    const clearButton = modal.querySelector(
      '[data-premium-search-clear]'
    );

    const startContent = modal.querySelector(
      '[data-premium-search-start]'
    );

    const loading = modal.querySelector(
      '[data-premium-search-loading]'
    );

    const resultsContainer = modal.querySelector(
      '[data-premium-search-results]'
    );

    const recentContainer = modal.querySelector(
      '[data-premium-search-recent]'
    );

    const recentList = modal.querySelector(
      '[data-recent-search-list]'
    );

    const clearRecentButton = modal.querySelector(
      '[data-clear-recent-searches]'
    );

    if (!form || !input || !resultsContainer) {
      return;
    }

    const RECENT_SEARCH_KEY =
      'tms_recent_product_searches';

    const SEARCH_DELAY = 280;

    const MONEY_FORMAT =
      modal.dataset.moneyFormat || 'RM {{amount}}';

    const PREDICTIVE_SEARCH_URL =
      modal.dataset.predictiveSearchUrl ||
      '/search/suggest';

    const SEARCH_URL =
      modal.dataset.searchUrl ||
      '/search';

    const SEARCH_TYPE =
      modal.dataset.searchType ||
      'product';

    let searchTimer = null;
    let activeController = null;

    function escapeHtml(value) {
      return String(value || '')
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;')
        .replace(/'/g, '&#039;');
    }

    function formatMoneyFromCents(cents) {
      const amount = (cents / 100).toFixed(2);

      const amountNoDecimals = String(
        Math.round(cents / 100)
      );

      const amountWithComma = amount
        .replace('.', ',');

      const amountWithSpace = amount
        .replace(
          /\B(?=(\d{3})+(?!\d))/g,
          ' '
        );

      return MONEY_FORMAT
        .replace(
          /\{\{\s*amount\s*\}\}/g,
          amount
        )
        .replace(
          /\{\{\s*amount_no_decimals\s*\}\}/g,
          amountNoDecimals
        )
        .replace(
          /\{\{\s*amount_with_comma_separator\s*\}\}/g,
          amountWithComma
        )
        .replace(
          /\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/g,
          amountNoDecimals
        )
        .replace(
          /\{\{\s*amount_with_apostrophe_separator\s*\}\}/g,
          amount
        )
        .replace(
          /\{\{\s*amount_no_decimals_with_space_separator\s*\}\}/g,
          amountNoDecimals
        )
        .replace(
          /\{\{\s*amount_with_space_separator\s*\}\}/g,
          amountWithSpace
        );
    }

    function formatProductPrice(value) {
      if (
        value === null ||
        typeof value === 'undefined' ||
        value === ''
      ) {
        return '';
      }

      /*
       * Some Shopify responses return a formatted price,
       * while others return a number or numeric string.
       */
      if (
        typeof value === 'string' &&
        /[A-Za-z$€£¥₹]/.test(value)
      ) {
        return value;
      }

      if (
        typeof value === 'string' &&
        value.indexOf('.') !== -1
      ) {
        const majorUnitAmount = Number(value);

        if (Number.isFinite(majorUnitAmount)) {
          return formatMoneyFromCents(
            Math.round(majorUnitAmount * 100)
          );
        }
      }

      const numericValue = Number(value);

      if (!Number.isFinite(numericValue)) {
        return String(value);
      }

      return formatMoneyFromCents(numericValue);
    }

    function getRecentSearches() {
      try {
        const storedSearches = JSON.parse(
          localStorage.getItem(
            RECENT_SEARCH_KEY
          ) || '[]'
        );

        return Array.isArray(storedSearches)
          ? storedSearches
          : [];
      } catch (error) {
        return [];
      }
    }

    function saveRecentSearch(query) {
      const cleanedQuery = query.trim();

      if (!cleanedQuery) {
        return;
      }

      const currentSearches =
        getRecentSearches().filter(
          function (item) {
            return (
              item.toLowerCase() !==
              cleanedQuery.toLowerCase()
            );
          }
        );

      currentSearches.unshift(cleanedQuery);

      try {
        localStorage.setItem(
          RECENT_SEARCH_KEY,
          JSON.stringify(
            currentSearches.slice(0, 5)
          )
        );
      } catch (error) {
        console.warn(
          '[Premium Search] Unable to save recent searches.',
          error
        );
      }

      renderRecentSearches();
    }

    function createSearchResultsUrl(query) {
      const url = new URL(
        SEARCH_URL,
        window.location.origin
      );

      url.searchParams.set('q', query);

      if (SEARCH_TYPE) {
        url.searchParams.set(
          'type',
          SEARCH_TYPE
        );
      }

      url.searchParams.set(
        'options[prefix]',
        'last'
      );

      return (
        url.pathname +
        url.search
      );
    }

    function renderRecentSearches() {
      if (
        !recentContainer ||
        !recentList
      ) {
        return;
      }

      const searches = getRecentSearches();

      if (!searches.length) {
        recentContainer.hidden = true;
        recentList.innerHTML = '';
        return;
      }

      recentContainer.hidden = false;

      recentList.innerHTML = searches
        .map(function (query) {
          return (
            '<a class="premium-search-chip" href="' +
            escapeHtml(
              createSearchResultsUrl(query)
            ) +
            '">' +
            escapeHtml(query) +
            '</a>'
          );
        })
        .join('');
    }

    function updateClearButton() {
      if (!clearButton) {
        return;
      }

      clearButton.hidden =
        input.value.trim().length === 0;
    }

    function resetSearchDisplay() {
      window.clearTimeout(searchTimer);

      if (activeController) {
        activeController.abort();
        activeController = null;
      }

      if (loading) {
        loading.hidden = true;
      }

      resultsContainer.hidden = true;
      resultsContainer.innerHTML = '';

      if (startContent) {
        startContent.hidden = false;
      }
    }

    function showLoading() {
      if (startContent) {
        startContent.hidden = true;
      }

      resultsContainer.hidden = true;
      resultsContainer.innerHTML = '';

      if (loading) {
        loading.hidden = false;
      }
    }

    function addImageWidthParameter(imageUrl) {
      if (!imageUrl) {
        return '';
      }

      try {
        const url = new URL(
          imageUrl,
          window.location.origin
        );

        url.searchParams.set(
          'width',
          '180'
        );

        return url.toString();
      } catch (error) {
        const separator =
          imageUrl.indexOf('?') > -1
            ? '&'
            : '?';

        return (
          imageUrl +
          separator +
          'width=180'
        );
      }
    }

    function renderProduct(product) {
  const productTitle = String(product.title || '').toLowerCase();

  // Never show GWP products in predictive search
  if (productTitle.includes('gwp')) {
    return '';
  }

  const featuredImage =
    product.featured_image || {};

      const imageUrl =
        featuredImage.url ||
        featuredImage.src ||
        '';

      const imageAlt =
        featuredImage.alt ||
        product.title ||
        '';

      const imageMarkup = imageUrl
        ? (
          '<img' +
          ' src="' +
          escapeHtml(
            addImageWidthParameter(imageUrl)
          ) +
          '"' +
          ' alt="' +
          escapeHtml(imageAlt) +
          '"' +
          ' width="180"' +
          ' height="180"' +
          ' loading="lazy"' +
          '>'
        )
        : (
          '<span class="' +
          'premium-search-product__placeholder' +
          '"></span>'
        );

      const vendorMarkup =
        product.vendor
          ? (
            '<p class="' +
            'premium-search-product__vendor' +
            '">' +
            escapeHtml(product.vendor) +
            '</p>'
          )
          : '';

      let priceMarkup = '';

            if (product.price) {

            // If Shopify already returned HTML
            if (
                typeof product.price === 'string' &&
                product.price.indexOf('<') > -1
            ) {

                priceMarkup =
                '<div class="premium-search-product__price">' +
                product.price +
                '</div>';

            } else {

                priceMarkup =
                '<div class="premium-search-product__price">' +
                formatProductPrice(product.price) +
                '</div>';

            }

            }

      return (
        '<a class="premium-search-product"' +
        ' href="' +
        escapeHtml(product.url) +
        '">' +
          '<span class="' +
          'premium-search-product__image' +
          '">' +
            imageMarkup +
          '</span>' +

          '<span class="' +
          'premium-search-product__info' +
          '">' +
            vendorMarkup +

            '<p class="' +
            'premium-search-product__title' +
            '">' +
              escapeHtml(product.title) +
            '</p>' +

            priceMarkup +
          '</span>' +
        '</a>'
      );
    }

    function renderCollection(collection) {
      return (
        '<a class="premium-search-collection"' +
        ' href="' +
        escapeHtml(collection.url) +
        '">' +
          escapeHtml(collection.title) +
        '</a>'
      );
    }

    function renderResults(data, query) {
      const resources =
        data &&
        data.resources &&
        data.resources.results
          ? data.resources.results
          : {};

      const products = Array.isArray(
        resources.products
      )
        ? resources.products
        : [];

      const collections = Array.isArray(
        resources.collections
      )
        ? resources.collections
        : [];

      let html = '';

      if (products.length) {
        html +=
          '<div class="' +
          'premium-search-results__section' +
          '">' +

            '<p class="premium-search-heading">' +
              'Products' +
            '</p>' +

            '<div class="' +
            'premium-search-product-list' +
            '">' +
              products
                .map(renderProduct)
                .join('') +
            '</div>' +
          '</div>';
      }

      if (collections.length) {
        html +=
          '<div class="' +
          'premium-search-results__section' +
          '">' +

            '<p class="premium-search-heading">' +
              'Collections' +
            '</p>' +

            '<div class="' +
            'premium-search-collection-list' +
            '">' +
              collections
                .map(renderCollection)
                .join('') +
            '</div>' +
          '</div>';
      }

      if (
        !products.length &&
        !collections.length
      ) {
        html =
          '<div class="premium-search-empty">' +
            '<p class="' +
            'premium-search-empty__title' +
            '">' +
              'No results found' +
            '</p>' +

            '<p class="' +
            'premium-search-empty__text' +
            '">' +
              'Try another keyword or check the spelling.' +
            '</p>' +
          '</div>';
      }

      html +=
        '<div class="premium-search-view-all">' +
          '<a class="' +
          'premium-search-view-all__link' +
          '" href="' +
          escapeHtml(
            createSearchResultsUrl(query)
          ) +
          '">' +
            'View all results for “' +
            escapeHtml(query) +
            '”' +
          '</a>' +
        '</div>';

      if (loading) {
        loading.hidden = true;
      }

      if (startContent) {
        startContent.hidden = true;
      }

      resultsContainer.innerHTML = html;
      resultsContainer.hidden = false;
    }

    function showSearchError() {
      if (loading) {
        loading.hidden = true;
      }

      if (startContent) {
        startContent.hidden = true;
      }

      resultsContainer.innerHTML =
        '<div class="premium-search-empty">' +
          '<p class="' +
          'premium-search-empty__title' +
          '">' +
            'Unable to load suggestions' +
          '</p>' +

          '<p class="' +
          'premium-search-empty__text' +
          '">' +
            'Press Enter to view the full search results.' +
          '</p>' +
        '</div>';

      resultsContainer.hidden = false;
    }

    function getPredictiveSearchEndpoint() {
      if (
        PREDICTIVE_SEARCH_URL.endsWith(
          '.json'
        )
      ) {
        return PREDICTIVE_SEARCH_URL;
      }

      return (
        PREDICTIVE_SEARCH_URL +
        '.json'
      );
    }

    function performPredictiveSearch(query) {
      const cleanedQuery = query.trim();

      if (cleanedQuery.length < 2) {
        resetSearchDisplay();
        return;
      }

      if (activeController) {
        activeController.abort();
      }

      activeController =
        new AbortController();

      showLoading();

      const parameters =
        new URLSearchParams();

      parameters.set(
        'q',
        cleanedQuery
      );

      parameters.set(
        'resources[type]',
        'product,collection'
      );

      parameters.set(
        'resources[limit]',
        '6'
      );

      parameters.set(
        'resources[options][unavailable_products]',
        'hide'
      );

      const requestUrl =
        getPredictiveSearchEndpoint() +
        '?' +
        parameters.toString();

      fetch(requestUrl, {
        signal: activeController.signal,
        headers: {
          Accept: 'application/json'
        }
      })
        .then(function (response) {
          if (!response.ok) {
            throw new Error(
              'Predictive search failed. Status: ' +
              response.status
            );
          }

          return response.json();
        })
        .then(function (data) {
          renderResults(
            data,
            cleanedQuery
          );
        })
        .catch(function (error) {
          if (error.name === 'AbortError') {
            return;
          }

          console.error(
            '[Premium Search]',
            error
          );

          showSearchError();
        });
    }

    input.addEventListener(
      'input',
      function () {
        window.clearTimeout(searchTimer);

        updateClearButton();

        const query =
          input.value.trim();

        if (query.length < 2) {
          resetSearchDisplay();
          return;
        }

        searchTimer =
          window.setTimeout(
            function () {
              performPredictiveSearch(
                query
              );
            },
            SEARCH_DELAY
          );
      }
    );

    input.addEventListener(
      'keydown',
      function (event) {
        if (
          event.key === 'Escape' &&
          input.value.trim().length
        ) {
          input.value = '';

          updateClearButton();
          resetSearchDisplay();

          event.stopPropagation();
        }
      }
    );

    if (clearButton) {
      clearButton.addEventListener(
        'click',
        function () {
          input.value = '';

          updateClearButton();
          resetSearchDisplay();

          input.focus();
        }
      );
    }

    if (clearRecentButton) {
      clearRecentButton.addEventListener(
        'click',
        function () {
          try {
            localStorage.removeItem(
              RECENT_SEARCH_KEY
            );
          } catch (error) {
            console.warn(
              '[Premium Search] Unable to clear recent searches.',
              error
            );
          }

          renderRecentSearches();
        }
      );
    }

    form.addEventListener(
      'submit',
      function (event) {
        const query =
          input.value.trim();

        if (!query) {
          event.preventDefault();
          input.focus();
          return;
        }

        saveRecentSearch(query);
      }
    );

    /*
     * Save a search when a customer clicks
     * "View all results".
     */
    resultsContainer.addEventListener(
      'click',
      function (event) {
        const link = event.target.closest(
          '.premium-search-view-all__link'
        );

        if (!link) {
          return;
        }

        saveRecentSearch(
          input.value.trim()
        );
      }
    );

    /*
     * The existing Showcase modal script changes
     * the modal's class or accessibility attributes.
     * This watches those changes and focuses the input.
     */
    // const modalObserver =
    //   new MutationObserver(
    //     function () {
    //       const computedStyle =
    //         window.getComputedStyle(modal);

    //       const modalIsVisible =
    //         computedStyle.display !== 'none' &&
    //         computedStyle.visibility !== 'hidden' &&
    //         computedStyle.opacity !== '0';

    //       if (modalIsVisible) {
    //         window.setTimeout(
    //           function () {
    //             input.focus();
    //           },
    //           180
    //         );
    //       }
    //     }
    //   );

    // modalObserver.observe(modal, {
    //   attributes: true,
    //   attributeFilter: [
    //     'class',
    //     'style',
    //     'aria-hidden'
    //   ]
    // });

    /*
 * Open only when the search icon/button in the header is clicked.
 */
document.addEventListener(
  'click',
  function (event) {
    const searchTrigger = event.target.closest(
      '[data-modal-toggle="#search-modal"]'
    );

    if (!searchTrigger) {
      return;
    }

    event.preventDefault();
    event.stopImmediatePropagation();

    openSearchModal();
  },
  true
);

/*
 * Close using the close button or backdrop.
 */
modal.addEventListener('click', function (event) {
  const closeTrigger = event.target.closest(
    '[data-modal-close]'
  );

  if (!closeTrigger) {
    return;
  }

  event.preventDefault();
  event.stopImmediatePropagation();

  closeSearchModal();
});

/*
 * Close with Escape.
 */
document.addEventListener('keydown', function (event) {
  if (
    event.key === 'Escape' &&
    modal.classList.contains(OPEN_CLASS)
  ) {
    closeSearchModal();
  }
});

/*
 * Always start closed on every page load.
 */
closeSearchModal();

    renderRecentSearches();
    updateClearButton();
  }

  if (
    document.readyState === 'loading'
  ) {
    document.addEventListener(
      'DOMContentLoaded',
      initializePremiumSearch
    );
  } else {
    initializePremiumSearch();
  }
})();